<div class="student-tabs d-flex flex-wrap">
  <a class="student-tab fs-small fw-800 clickable d-inline-flex align-items-center px-3 py-2 me-2 mb-2"
     *ngFor="let tab of tabs"
     [class.active]="tab.key === activeTab" [class.disabled]="tab.disabled"
     (click)="select(tab)">
    <i class="bi {{tab.icon}} me-2"></i>
    {{tab.labelKey|translate}}
    <span class="tab-badge fs-xsmall fw-800 ms-2" *ngIf="tab.key === 'planner' && plannerProgress">
      {{plannerProgress}}
    </span>
    <span class="tab-badge fs-xsmall fw-800 ms-2" *ngIf="tab.key === 'tasks' && taskProgress">
      {{taskProgress}}
    </span>
    <span class="tab-badge unread fs-xsmall fw-800 ms-2" *ngIf="tab.key === 'messages' && unreadMessages">
      {{unreadMessages}}
    </span>
  </a>
</div>
